/**
 * Join serving unit prefix/name/suffix for display labels.
 *
 * Inserts a space between parts when bordering whitespace is omitted (recipe
 * redesign), but does not insert a space before punctuation such as ", bits".
 * Legacy values that already embed spacing are preserved.
 */
export const joinServingUnitParts = (unitPrefix, unitName, unitSuffix) => [unitPrefix, unitName, unitSuffix].reduce((acc, part) => {
    if (!part) {
        return acc;
    }
    if (!acc) {
        return part;
    }
    if (/\s$/.test(acc) || /^\s/.test(part) || /^[,.;:!?]/.test(part)) {
        return acc + part;
    }
    return `${acc} ${part}`;
}, "");
//# sourceMappingURL=joinServingUnitParts.js.map